
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import SearchBoxModal from "../component/SearchBoxModal";

export default function FormLinkUV() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const defaultdetail = {
        company_id: '', author_id: user.data.id, shortname: '', title: '', vanthu: '', list_master: '', status: 1,
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "link_ungvien/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let detail = res.data.data
                                setDetail(detail);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            campaign_name: Yup.string().trim().nullable().required('Nhập tên chiến dịch').max(150, "Độ dài không quá 150 ký tự")
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (values.campaign_alias) {
                values.link = "https://ungvien.bhsgroup.vn/?campaign=" + values.campaign_alias
            }
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'link_ungvien/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật Link ứng viên thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'link_ungvien', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới Link ứng viên thành công',
                            buttons: [{ label: 'OK' }]
                        });
                        window.location.href = "/edit-link_ungvien/" + res.data.id
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const toAlias = (text) => {
        return text
            .normalize("NFD")                     // tách ký tự có dấu thành ký tự thường + dấu
            .replace(/[\u0300-\u036f]/g, "")     // xoá dấu
            .toLowerCase()                       // về chữ thường
            .trim()                              // bỏ khoảng trắng 2 đầu
            .replace(/[^a-z0-9\s-]/g, "")        // bỏ ký tự đặc biệt
            .replace(/\s+/g, "-")                // thay khoảng trắng bằng gạch ngang
            .replace(/-+/g, "-");                // gộp nhiều dấu - liên tiếp thành 1
    }

    return (
        <AkkhorLayout idrole="link-ung-vien">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/link-ung-vien">Quản lý Link thông tin ứng viên</Link>
                    </li>
                    <li>{id ? 'Sửa Link ứng viên' : 'Thêm mới Link ứng viên'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Link đăng ký ứng viên</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tên chiến dịch <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" defaultValue={formik && formik.values['campaign_name']} onChange={(e) => {
                                    formik.setFieldValue('campaign_alias', toAlias(e.target.value));
                                    formik.setFieldValue('campaign_name', e.target.value)
                                }} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="campaign_name"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tên rút gọn</label>
                                <input type="text" placeholder="" readOnly className="form-control height32" {...formik.getFieldProps("campaign_alias")} autoComplete="off" />
                            </div>
                            <div className="col-xs-12"></div>
                            {formik && formik.values && formik.values['campaign_alias'] &&
                                <div className="col-12 col-sm-6 form-group">
                                    <label>Link</label>
                                    <a target="_blank" className="form-control height32" href={"https://ungvien.bhsgroup.vn?campaign=" + formik.values['campaign_alias']}>{"https://ungvien.bhsgroup.vn?campaign=" + formik.values['campaign_alias']}</a>
                                </div>
                            }
                            <div className="col-12 col-sm-6 form-group">
                                <label>Đơn vị </label>
                                <SearchBoxModal apiname={"parts"} placeholder="Chọn đơn vị" colvalue={'id'} colname={'title'} defaultValue={formik.values['department_id']} name='department_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('department_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="department_id"></AlertErrorForm>
                            </div>

                            <div className="col-12 col-sm-6 form-group">
                                <label>Vị trí </label>
                                <SearchBoxModal apiname={"chucvu"} placeholder="Chọn vị trí" colvalue={'id'} colname={'title'} defaultValue={formik.values['chucvu_id']} name='chucvu_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('chucvu_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="chucvu_id"></AlertErrorForm>
                            </div>


                            <div className="col-12 col-sm-6 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Khoá</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>
                            <div className="col-xs-12"></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
